import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { ClientesService } from 'src/app/services/clientes.service';
import { environment } from '../../../environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-anillos',
  templateUrl: './anillos.component.html',
  styleUrls: ['./anillos.component.scss']
})
export class AnillosComponent implements OnInit {
  enviroment = environment.BASE_URL;
  respuestaFiestas:any;
  respuestaDatos:any;
  respuestaAgregar:any;
  respuestaUpdate:any;
  respuestaAnillos:any;
  formulario;
  formularioEdit;
  anillos;
  data;
  datos;
  imagenActual;
  anilloId;

  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(private _getFiestas:ClientesService, private _getDetalleAnillo:ClientesService,
    private _agregarAnillo: ClientesService,
    private modalService: NgbModal,
    private _updateAnillo: ClientesService,
    private iziToast: Ng2IzitoastService, private _getAnillos: ClientesService) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 20,
      processing: true
    };

    this.formulario = {
      'nombre':'',
      'descripcion':'',
      'imagen':'',
      'precio':'',
    }

    this.formularioEdit = {
      nombre: '',
      descripcion: '',
      imagen: '',
      precio: ''
    }

    this.getAnillos();
  }

  getAnillos(){
    this._getAnillos.getAnillos().subscribe(
      data => {
        this.respuestaAnillos = data;
        if(this.respuestaAnillos.success){
          this.anillos = this.respuestaAnillos.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  agregarAnillo(){
    const formData = new FormData();
    formData.append('nombre', this.formulario.nombre);
    formData.append('gramaje', this.formulario.gramaje);
    formData.append('metal', this.formulario.metal);
    formData.append('precio', this.formulario.precio);

    if (this.formulario.imagen){ 
      formData.append('imagen', this.formulario.imagen);
    }


    this._agregarAnillo.agregarAnillo(formData).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.nombre = '';
          this.formulario.imagen = '';
          this.dtTrigger.unsubscribe();
          this.dismissAll();
          this.getAnillos();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }


  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }

  imageChangeEdit(files: FileList){
    this.formularioEdit.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen.type.toString() == 'image/png' ||
        this.formularioEdit.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen.size > 10485760) {
          this.formularioEdit.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen);
    } else {
      this.formularioEdit.imagen = null;
      $('#imagen').focus();
      return;
    }
  }

  getDetalleAnillo(anillo){
    this.data = {
      'anillo':anillo,
    }
    this._getDetalleAnillo.getDetalleAnillo(this.data).subscribe(
      data => {
        this.respuestaDatos = data;
        if(this.respuestaDatos.success){
          this.datos = this.respuestaDatos.content;
          this.formularioEdit.nombre = this.datos.nombre;
          this.formularioEdit.precio = this.datos.precio;
          this.formularioEdit.gramaje = this.datos.gramaje;
          this.formularioEdit.metal = this.datos.metal;
          this.imagenActual = this.datos.imagen;
          this.anilloId = this.datos.id;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  updateAnillo(anillo){
    const formData = new FormData();
    formData.append('nombre', this.formularioEdit.nombre);

    formData.append('anillo', anillo);

    if (this.formularioEdit.imagen){ 
      formData.append('imagen', this.formularioEdit.imagen);
    }

    this._updateAnillo.updateAnillo(formData).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getAnillos();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
